<template>
  <div id="main-wrapper">
    <div v-if="success">
      <div class="mfp-bg animated zoomIn mfp-ready"></div>
      <div class="mfp-wrap mfp-close-btn-in mfp-auto-cursor animated zoomIn mfp-ready" tabindex="-1" style="overflow: hidden auto;">
        <div class="mfp-container mfp-s-ready mfp-inline-holder">
          <div class="mfp-content">
            <div id="upload-confirm" class="white-popup-block popup-content popup-small">
              <div class="content t-white t-left">
                <!-- <p>Please click on the link sent to your registered email address to confirm the Change of Password</p> -->
                 <p>{{$t("change_pass.success_message")}}</p>
              </div>
              <div class="btn-holder t-center">
                <a href="#" class="btn btn-lblue close-popup" @click.prevent="success = false">{{$t("change_pass.ok")}}</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="content-container profile-page personal-details change-pass">
      <div class="page-wrap">
        <div class="page-content clearfix">
          <div class="main-content f-left">
            <div class="title-holder">
              <h4>{{$t("change_pass.change_password")}}</h4>
            </div>
            <div class="content-holder wow fadeInLeft">
              <div class="row-sec">
                <div class="form-holder">
                  <Form @submit="submit">
                    <ul class="clearfix">
                      <li>
                        <label for="">{{$t("change_pass.existing_password")}} <span style="color: #da1c1c">*</span></label>
                        <Field
                          rules="required"
                          type="text"
                          name="old password"
                          v-model="form.oldpassword"
                        />
                        <ErrorMessage name="old password" />
                      </li>
                      <li>
                        <label for="" >{{$t("change_pass.new_password")}} <span style="color: #da1c1c">*</span></label>
                        <Field
                          rules="required"
                          type="text"
                          name="password"
                          v-model="form.password"
                        />
                        <ErrorMessage name="password" />
                      </li>
                      <li>
                        <label for="" >{{$t("change_pass.confirm_new_password")}} <span style="color: #da1c1c">*</span></label>
                        <Field
                          rules="required|confirmed:@password"
                          type="text"
                          name="confirm password"
                          v-model="form.cpassword"
                        />
                        <ErrorMessage name="confirm password" />
                      </li>
                      <div class="note">
                        <p>* {{$t("change_pass.note_one")}}<br /><br /> {{$t("change_pass.note_two")}}</p>
                      </div>
                    </ul>
                    <div class="btn-holder t-center">
                      <button type="submit" class="btn btn-yellow popup-link-holder">
                        {{$t("change_pass.change_password")}}
                      </button>
                      <a href="" class="btn btn-blue">{{$t("change_pass.cancel")}}</a>
                    </div>
                  </Form>
                </div>
              </div>
            </div>
            <div class="img-holder t-center wow fadeInRight va-top">
              <img src="assets/images/pass-img.png" alt="" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useMainStore } from "@/store";
import { Form, Field, ErrorMessage } from "vee-validate";

export default {
  setup() {
    const store = useMainStore();
    return { store };
  },
  data() {
    return {
      form: {
        oldpassword: "",
        password: "",
        cpassword: "",
      },
      success : false
    };
  },
  components: {
    Form,
    Field,
    ErrorMessage,
  },
  methods: {
    submit() {
      this.store.changePassword(this.form, true,this);
    },
  },
};
</script>
